export default "__VITE_ASSET__BoyEJhen__"